import { ComponentProps, PropsWithChildren } from 'react';
import { Typography, TypographyProps } from 'antd';

const { Title: AntTitle } = Typography;
/**
 * @deprecated Use shared/uikit/Title
 */
export const Title = ({
  children,
  style,
  ...props
}: PropsWithChildren<Partial<ComponentProps<TypographyProps['Title']>>>) => (
  <AntTitle style={{ ...style, fontFamily: 'Manrope' }} {...props}>
    {children}
  </AntTitle>
);
